/**
 * FIRST STRONG ISOLATE / POP DIRECTIONAL ISOLATE — the character form of `<bdi>`.
 * Used where the text is interpolated into a translated string, so markup is not
 * an option.
 */
const FSI = "⁨";
const PDI = "⁩";

/**
 * Fence a fragment so surrounding text cannot reorder it, and it cannot reorder
 * its neighbours.
 *
 * Needed whenever two number-bearing fragments are joined by neutral punctuation
 * inside an RTL line: a formatted percent carries U+200E marks, which open an
 * LTR run that swallows the separator and the next figure, silently swapping the
 * two numbers on screen. Isolating each fragment is what prevents that.
 */
export function isolate(fragment: string): string {
  return `${FSI}${fragment}${PDI}`;
}
